import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const StatsSchema = withDefaults({
  type: 'stats',
  fields: [
    { name: 'totalItems', kind: 'attribute', type: 'number' },
    { name: 'totalMentions', kind: 'attribute', type: 'number' },
    { name: 'totalCreators', kind: 'attribute', type: 'number' },
    { name: 'totalContentSources', kind: 'attribute', type: 'number' },
    { name: 'totalPodcasts', kind: 'attribute', type: 'number' },
    { name: 'totalRecipes', kind: 'attribute', type: 'number' },
    { name: 'totalContentSources', kind: 'attribute', type: 'number' },
    { name: 'byType', kind: 'attribute', type: 'object' },
    { name: 'itemsByType', kind: 'attribute', type: 'object' },
    { name: 'byPlatform', kind: 'attribute', type: 'object' },
    { name: 'avgSentiment', kind: 'attribute', type: 'number' },
    { name: 'topCreators', kind: 'attribute', type: 'object' },
  ],
});
